module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/solid/star.svg?ccaa1303d931e1b029797a955ba0ed48";